/* eslint-disable */
import alarmClock from './alarm-clock'
import briefcase from './briefcase'
import calendar from './calendar'
import calendarStar from './calendar-star'
import caretLeft from './caret-left'
import caretRight from './caret-right'
import chatQuestion from './chat-question'
import chat from './chat'
import checkmark from './checkmark'
import clock from './clock'
import close from './close'
import cog from './cog'
import compactList from './compact-list'
import cookie from './cookie'
import deleteIcon from './delete'
import edit from './edit'
import exclamationCircle from './exclamation-circle'
import fullList from './full-list'
import funnel from './funnel'
import minusCircle from './minus-circle'
import moon from './moon'
import more from './more'
import notifications from './notifications'
import personOff from './person-off'
import person from './person'
import piggyEur from './piggy-eur'
import pin from './pin'
import plusCircle from './plus-circle'
import plusTimer from './plus-timer'
import ringing from './ringing'
import search from './search'
import star from './star'
import suitcase from './suitcase'
import thumbsUpFilled from './thumbs-up-filled'
import thumbsUp from './thumbs-up'
import times from './times'
import trash from './trash'

export default Object.freeze({
  'alarm-clock': alarmClock,
  'briefcase': briefcase,
  'calendar': calendar,
  'calendar-star': calendarStar,
  'caret-left': caretLeft,
  'caret-right': caretRight,
  'chat-question': chatQuestion,
  'chat': chat,
  'checkmark': checkmark,
  'clock': clock,
  'close': close,
  'cog': cog,
  'compact-list': compactList,
  'cookie': cookie,
  'delete': deleteIcon,
  'edit': edit,
  'exclamation-circle': exclamationCircle,
  'full-list': fullList,
  'funnel': funnel,
  'minus-circle': minusCircle,
  'moon': moon,
  'more': more,
  'notifications': notifications,
  'person-off': personOff,
  'person': person,
  'piggy-eur': piggyEur,
  'pin': pin,
  'plus-circle': plusCircle,
  'plus-timer': plusTimer,
  'ringing': ringing,
  'search': search,
  'star': star,
  'suitcase': suitcase,
  'thumbs-up-filled': thumbsUpFilled,
  'thumbs-up': thumbsUp,
  'times': times,
  'trash': trash,
})
